import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function LevelItem({ className, children, ...rest }) {
  return (
    <div className={cleanJoin("level-item", className)} {...rest}>
      {children}
    </div>
  );
}

export default LevelItem;
